import React, { useEffect, useRef, useState } from 'react';
import { FaCheck, FaPlus, FaRegFilePdf, FaSave } from 'react-icons/fa';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoPrint } from 'react-icons/io5';
import { LuView } from 'react-icons/lu';
import { MdEdit } from 'react-icons/md';
import { RiCloseLargeFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import A1 from '../../Images/logo-w.png';
import axios from 'axios';
import Select from 'react-select'

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { pdf } from '@react-pdf/renderer';
// import ReactPDF, { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';

import { Container, Row, Col, Form, Button, ListGroup, Card, Table } from 'react-bootstrap';
import './POvsMR.css';
import Modal from "react-modal";
import { saveAs } from "file-saver";
import { toWords } from 'number-to-words';






const PO_TC = () => {
    // const [isModalOpen, setIsModalOpen] = useState(false);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const id = user ? user.id : null;




    const [currentDate, setCurrentDate] = useState('');


    useEffect(() => {
        const date = new Date();
        const formattedDate = date.toISOString().split('T')[0];
        setCurrentDate(formattedDate);
    }, []);


    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    const [formMode, setFormMode] = useState('');

    // const userPermissions = user ? {
    //     add: user.add_permission,
    //     edit: user.edit_permission,
    //     view: user.view_permission,
    //     save: user.save_permission,
    //     approve: user.approve_permission,
    //     print: user.print_permission,
    //     close: user.close_permission,
    //     clear: user.clear_screen_permission
    // } : {};

    // const userPermissions = user && user.permissions && user.permissions[1000]
    // ? {
    //     add: user.permissions[3000].sub_ids[3003]?.permissions.add_permission || 0,
    //     edit: user.permissions[3000].sub_ids[3003]?.permissions.edit_permission || 0,
    //     view: user.permissions[3000].sub_ids[3003]?.permissions.view_permission || 0,
    //     save: user.permissions[3000].sub_ids[3003]?.permissions.save_permission || 0,
    //     approve: user.permissions[3000].sub_ids[3003]?.permissions.approve_permission || 0,
    //     print: user.permissions[3000].sub_ids[3003]?.permissions.print_permission || 0,
    //     close: user.permissions[3000].sub_ids[3003]?.permissions.exit_permission || 0,
    //     clear: user.permissions[3000].sub_ids[3003]?.permissions.refresh_permission || 0
    // }
    // : {};
    // const userPermissions = user && user.permissions && user.permissions[1000]
    //     ? {
    //         add: user.permissions[2000].sub_ids[2003]?.permissions.add_permission || 0,
    //         edit: user.permissions[2000].sub_ids[2003]?.permissions.edit_permission || 0,
    //         view: user.permissions[2000].sb_ids[2003]?.permissions.view_permission || 0,
    //         save: user.permissions[2000].sub_ids[2003]?.permissions.save_permission || 0,
    //         approve: user.permissions[2000].sub_ids[2003]?.permissions.approve_permission || 0,
    //         print: user.permissions[2000].sub_ids[2003]?.permissions.print_permission || 0,
    //         close: user.permissions[2000].sub_ids[2003]?.permissions.exit_permission || 0,
    //         clear: user.permissions[2000].sub_ids[2003]?.permissions.refresh_permission || 0
    //     }
    //     : {};

    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'view' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };


    const [fromDate, setFromDate] = useState(null);


    // Function to format date to YYYY-MM-DD
    const formatDateToDateInput = (date) => {
        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    const [poList, setPoList] = useState(['']);

    const [supplierList, setSupplierList] = useState([]); // Supplier data




    const getSupplierName = (supp_id) => {
        const supplier = supplierList.find(s => s.Supp_cd === supp_id);
        return supplier ? supplier.Supp_Nm : 'Unknown Supplier'; // Return supplier name or 'Unknown Supplier' if not found
    };

    useEffect(() => {
        const fetchPOData = async () => {
            try {
                // Fetch Purchase Orders
                const poResponse = await axios.get('https://erpapi.emedha.in/pages/api/poget/MatirialReceipt');
                setPoList(poResponse.data);


                const suppResponse = await axios.get('https://erpapi.emedha.in/pages/api/purSuppMst'); // Replace with your actual API endpoint  https://erpapi.emedha.in
                setSupplierList(suppResponse.data); // Assuming this API returns an array of suppliers
            } catch (error) {
                console.error("Error fetching purchase orders or suppliers", error);
            }
        };

        fetchPOData();
    }, []);



    // Filter combinedData based on selected date range
    const [rows, setRows] = useState(Array.from({ length: 10 }, () => ({ remarks: '', })));

    const handleAddRow = () => {
        setRows((prevRows) => [
            ...prevRows,
            // { remarks: '', }
            { remarks: '', image1: null }
        ]);
    };

    const [states, setStates] = useState({});
    const [stateName, setStateName] = useState('');
    const [stateNamee, setStateNamee] = useState('');

    const [suppliers, setSuppliers] = useState([]);
    const [supplierName, setSupplierName] = useState('');


    const [PO_no, setPO_no] = useState('');
    const [poData, setPoData] = useState(null);
    const [poNumbers, setPoNumbers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch available PO numbers on initial render
    useEffect(() => {
        const fetchPONumbers = async () => {
            try {
                const response = await axios.get('https://erpapi.emedha.in/pages/api/api/po-numbers');
                setPoNumbers(response.data);
            } catch (err) {
                console.error("Error fetching PO numbers", err);
            }
        };
        fetchPONumbers();
    }, []);

    // Fetch data for the selected PO_no when it changes
    useEffect(() => {
        if (!PO_no) return;

        const fetchPoData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await axios.get(`https://erpapi.emedha.in/pages/api/PURCHASE_ORDER/${PO_no}`);
                setPoData(response.data);
            } catch (err) {
                console.error("Error fetching PO data", err);
                setError('Failed to fetch purchase order data');
            } finally {
                setLoading(false);
            }
        };

        fetchPoData();
    }, [PO_no]);  // This effect runs whenever PO_no changes

    const latestPO = poNumbers.length > 0 ? Math.max(...poNumbers) : null;

    const poOptions = poNumbers.map((poNumber) => ({
        value: poNumber,
        label: poNumber,
    }));


    const handlePOSelectChange = (selectedOption) => {
        setPO_no(selectedOption ? selectedOption.value : '');
        setPoData(null);  // Reset PO data when a new PO is selected
    };

    const fetchStateMaster = () => {
        axios.get('https://erpapi.emedha.in/pages/api/api/states')
            .then((response) => {
                setStates(response.data);

            })
            .catch((error) => {
                console.error('Error fetching state master:', error);
            });

    }
    useEffect(() => {
        fetchStateMaster();
    }, []);


    useEffect(() => {
        // Ensure PO data and states are loaded
        if (poData && poData.PO_HDR && states) {
            const stateCode = poData.PO_HDR.Supp_gst.slice(0, 2); // Extract first 2 characters (state code)
            const state = states[stateCode]; // Find the state by code
            if (state) {
                setStateName(state); // Set state name if found
            } else {
                setStateName('Unknown State'); // Default in case the state is not found
            }
        }
    }, [poData, states]);

    useEffect(() => {
        // Ensure PO data and states are loaded
        if (poData && poData.PO_HDR && states) {
            const stateCode = poData.PO_HDR.Des_state_cd; // Extract first 2 characters (state code)
            const state = states[stateCode]; // Find the state by code
            if (state) {
                setStateNamee(state); // Set state name if found
            } else {
                setStateNamee('Unknown State'); // Default in case the state is not found
            }
        }
    }, [poData, states]);


    useEffect(() => {
        // Ensure poData and PO_HDR exist before accessing
        const suppId = poData?.PO_HDR?.Supp_id;

        if (suppId) {
            const supplier = suppliers.find(sup => sup.Supp_cd === suppId);
            if (supplier) {
                setSupplierName(supplier.Supp_Nm); // Set the supplier name
            }
        }
    }, [poData, suppliers]);

    const fetchSuppliers = () => {
        axios.get('https://erpapi.emedha.in/pages/api/api/suppliers')
            .then((response) => {
                setSuppliers(response.data);
            })
            .catch((error) => {
                console.error('Error fetching suppliers:', error);
            });
    };

    useEffect(() => {
        fetchSuppliers();
    }, []);

    const handleRemarksChange = (index, event) => {
        const updatedRows = [...rows];
        updatedRows[index].remarks = event.target.value;
        setRows(updatedRows);
    };



    const handleFileChange = (index, event, field) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = event.target.files[0];
        setRows(updatedRows);
    };

    // const handleSubmit = async () => {
    //     try {
    //         for (const row of rows) {
    //             if (row.remarks) {
    //                 await axios.post('https://erpapi.emedha.in/pages/api/api/insert-po-data', {
    //                     PO_no: PO_no,
    //                     remarks: row.remarks,
    //                 });
    //             }
    //         }
    //         alert('Data inserted successfully!');
    //         setPO_no('');  // Reset PO_no
    //         setRows(Array.from({ length: 10 }, () => ({ remarks: '' })));

    //     } catch (error) {
    //         console.error('Error inserting data:', error);
    //         alert('Error inserting data.');
    //     }
    // };

    const buttonContainerStyle = {
        display: "flex",             // Enables flexbox
        gap: "40px",                 // Adds space between each button
        alignItems: "center"         // Aligns buttons vertically in the center
    };

    const buttonStyle = {
        padding: "10px 20px",        // Adjust padding for the button
        color: 'blue',
        backgroundColor: 'transparent'
    };


    //   const handleSubmit = async () => {
    //     try {
    //       for (const row of rows) {
    //         if (row.remarks) {
    //           const formData = new FormData();
    //           formData.append('PO_no', PO_no);
    //           formData.append('remarks', row.remarks);
    //           formData.append('image1', files.image1);
    //           formData.append('image2', files.image2);
    //           formData.append('image3', files.image3);

    //           await axios.post('https://erpapi.emedha.in/pages/api/api/insert-po-data', formData, {
    //             headers: {
    //               'Content-Type': 'multipart/form-data',
    //             },
    //           });
    //         }
    //       }
    //       alert('Data inserted successfully!');
    //       setPO_no('');  // Reset PO_no
    //       setRows(Array.from({ length: 10 }, () => ({ remarks: '' })));
    //       setFiles({ image1: null, image2: null, image3: null });  // Reset file inputs
    //     } catch (error) {
    //       console.error('Error inserting data:', error);
    //       alert('Error inserting data.');
    //     }
    //   };

    const handleSubmit = async () => {
        try {
            for (const row of rows) {
                if (row.remarks) {
                    const formData = new FormData();
                    formData.append('PO_no', PO_no);
                    formData.append('remarks', row.remarks);

                    // Append the image files (if they exist for the row)
                    if (row.image1) formData.append('image1', row.image1);
                    // if (row.image2) formData.append('image2', row.image2);
                    // if (row.image3) formData.append('image3', row.image3);

                    await axios.post('https://erpapi.emedha.in/pages/api/api/insert-po-data', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                }
            }

            alert('Data inserted successfully!');
            setPO_no('');  // Reset PO_no
            setRows(Array.from({ length: 10 }, () => ({ remarks: '', image1: null, image2: null, image3: null })));  // Reset rows
            window.location.reload();
        } catch (error) {
            console.error('Error inserting data:', error);
            alert('Error inserting data.');
        }
    };

    return (
 
        <div style={{ margin: '0 auto', backgroundColor: '#ffffff', padding: '1rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid black', borderRadius: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={A1} alt="item" style={{ width: "20%" }} />
                <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>PURCHASEORDER TERMS & CONDITIONS</h1>
                <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>

                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",

                    }}>
                        <FaSave size={30} onClick={handleSubmit} />
                    </div>
                    {/* <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",

                    }} title='Print'>
                        <IoPrint size={30} />
                    </div> */}
                    {/* <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                        opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                    }} title='Exit'>
                        <RiCloseLargeFill size={30} onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null} />
                    </div> */}
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        // cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                        // opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                    }} title='Exit'>
                        <RiCloseLargeFill size={30}
                            onClick={handleBack}
                        //  onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
                        />
                    </div>
                </div>
            </div>
            <hr />

            <>
                <Container>
                    <Row className="mt-4">
                        <Col>
                            <div>
                                <Row>
                                    <Col md={4} style={{ display: 'flex', alignItems: 'end' }}>
                                        <label style={{ marginRight: '105px', color: 'darkblue' }}>PO No :</label>

                                        <Select
                                            key={PO_no}
                                            options={poOptions}
                                            value={poOptions.find((option) => option.value === PO_no)}
                                            onChange={handlePOSelectChange}
                                            placeholder="Select PO No"
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: '40%',
                                                }),
                                                menuPortal: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: '60%',
                                                    overflowY: 'auto',
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    backgroundColor: "transparent",
                                                    height: '25px',
                                                    padding: '4px',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: 'black',
                                                }),
                                            }}
                                        />
                                    </Col>
                                    <Col md={4} className="text-center">

                                    </Col>
                                    <br></br>
                                </Row>

                            </div>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <div style={{ overflowY: 'auto', maxHeight: '530px' }}>
                            <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>

                                <thead>
                                    <tr>

                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Serial Number</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Enter your Terms and Condition</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Attachments </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {rows.map((row, index) => (
                                        <tr>
                                            <td style={{ width: '10%', textAlign: 'center', border: '1px solid black', }}>{index + 1}</td>


                                            <td style={{ border: '1px solid black' }}>
                                                <input
                                                    name="Remarks"
                                                    type="text"
                                                    style={{ border: 'black', height: '50px', outline: 'black', width: '100%', backgroundColor: 'transparent' }}
                                                    value={row.remarks}
                                                    onChange={(event) => handleRemarksChange(index, event)}
                                                />
                                            </td>
                                        </tr>

                                    ))} */}

                                    {rows.map((row, index) => (
                                        <>
                                            <tr>
                                                <td style={{ width: '10%', textAlign: 'center', border: '1px solid black', }}>{index + 1}</td>

                                                <td style={{ border: '1px solid black' }}>
                                                    <input
                                                        name="Remarks"
                                                        type="text"
                                                        style={{ border: 'black', height: '50px', outline: 'black', width: '100%', backgroundColor: 'transparent' }}
                                                        value={row.remarks}
                                                        onChange={(event) => handleRemarksChange(index, event)}
                                                    />
                                                </td>


                                                <td style={{ width: '20%', border: '1px solid black' }} >

                                                    <input
                                                        type="file"
                                                        onChange={(event) => handleFileChange(index, event, 'image1')}
                                                        accept="image/*"
                                                        style={{ border: 'black', height: '50px', outline: 'black', width: '100%', backgroundColor: 'transparent' }}

                                                    />

                                                    {/* <button style={buttonStyle}>
                                                        <input
                                                            type="file"
                                                            onChange={(event) => handleFileChange(index, event, 'image2')}
                                                            accept="image/*"
                                                        />
                                                    </button>
                                                    <button style={buttonStyle}>
                                                        <input
                                                            type="file"
                                                            onChange={(event) => handleFileChange(index, event, 'image3')}
                                                            accept="image/*"
                                                        />
                                                    </button>
 */}

                                                </td>
                                            </tr>
                                        </>
                                    ))}

                                    <tr>
                                        <td colSpan="12" style={{ textAlign: 'end', border: '1px solid black' }}><button onClick={handleAddRow} style={{ padding: '5px 10px', border: '1px solid #D1D5DB', backgroundColor: 'transparent' }}><FaPlus /> Add Row</button></td>
                                    </tr>
                                </tbody >
                            </table>


                        </div>
                        {/* <div style={buttonContainerStyle} >
                            <button style={buttonStyle}>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e, 'image1')}
                                    accept="image/*"
                                />
                            </button>
                            <button style={buttonStyle}>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e, 'image2')}
                                    accept="image/*"
                                />
                            </button>
                            <button style={buttonStyle}>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e, 'image3')}
                                    accept="image/*"
                                />
                            </button>


                        </div> */}


                    </Row>

                </Container>
            </>

        </div >
    );
};

export default PO_TC;




{/* {poData && !loading && !error && (
                                    <div>



                                        <div><h5>TO</h5></div>

                                        <div className='p-1' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>


                                            <div>



                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '64px', color: 'darkblue' }}>Supplier:</label>

                                                    <input value={supplierName} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '32px', color: 'darkblue' }}>Supplier GST:</label>
                                                    <input type="text" name="Supp_gst" value={poData.PO_HDR.Supp_gst} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '25px', color: 'darkblue' }}>Supplier State:</label>
                                                    <input type="text" name="Supp_state_cd" value={stateName} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                            
                                                <h5>INVOICE TO -</h5>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '25px', color: 'darkblue' }}>Company Name:</label>
                                                    eMedha Technologies
                                                </div>
                                            </div>

                                            <div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '86px', color: 'darkblue' }}>PO NO:</label>

                                                    <input value={PO_no} maxLength={20} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />

                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '88px', color: 'darkblue' }}>P O Dt:</label>
                                                    <input name="PO_Dt" value={formatDateToDateInput(poData.PO_HDR.PO_Dt)} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '28px', color: 'darkblue' }}>Payment Terms:</label>
                                                    <input type="text" name="Pay_terms" value={poData.PO_HDR.Pay_terms} maxLength={20} pattern="[A-Za-z0-9]+" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '32px', color: 'darkblue' }}>Delivery Terms:</label>
                                                    <input type="text" name="Deli_terms" value={poData.PO_HDR.Deli_terms} maxLength={20} pattern="[A-Za-z0-9]+" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '57px', color: 'darkblue' }}>Delivery Dt:</label>
                                                    <input value={formatDateToDateInput(poData.PO_HDR.Deli_dt)} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                            </div>

                                            <div>

                                               

                                            </div>
                                        </div>


                                        <div className="table-responsive" style={{ overflowY: 'auto', maxHeight: '150px' }}>
                                            <div>
                                                <table className="table" style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>

                                                            

                                                            <th colSpan="2" className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>SGST</th>

                                                            <th colSpan="2" className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>CGST</th>
                                                            <th colSpan="2" className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>IGST</th>

                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                        </tr>

                                                        <tr>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Sl</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Item Code</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Item Description</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>UOM</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>HSN CODE</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Indent Qty</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>PO Qty</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Item Rate</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Disc %</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Taxable amt</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>%</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Amt</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>%</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Amt</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>%</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Amt</th>

                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Total Amt</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {poData.PO_DTL.map((indent, index) => (
                                                            <tr key={index}>
                                                                <td style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{index + 1}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.itemCd}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.itemDesc}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.UOM}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Hsn_code}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.qty}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.PO_qty}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Item_rate}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Disc_per}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Taxable_amt}</td>

                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Sgst_per}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Sgst_amt}</td>

                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Cgst_per}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Cgst_amt}</td>

                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Igst_per}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Igst_amt}</td>

                                                                <td style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Net_amt}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <>

                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '10px' }}>

                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px', width: '250px', marginBottom: '20px' }}>

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                        <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}><strong>Totals:</strong></label>
                                                        {(poData.PO_HDR.Total_amt - poData.PO_HDR.Freight_amt - poData.PO_HDR.Insurance_amt - poData.PO_HDR.Oth_amt).toFixed(2)}
                                                    </div>
                                                </div>

                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px', width: '250px' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                        <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}>Freight amt:</label>
                                                        <input name="Freight_amt" value={poData.PO_HDR.Freight_amt}

                                                            style={{ textAlign: 'right', border: 'none', borderLeft: '2px solid #D1D5DB', minWidth: '80px', outline: 'none', backgroundColor: 'transparent' }}
                                                            maxLength={10} pattern="[A-Za-z0-9]+" />
                                                    </div>

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                        <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}>
                                                            Insurace amt:</label>
                                                        <input type="text" name="Insurance_amt"
                                                            value={poData.PO_HDR.Insurance_amt}
                                                            style={{ textAlign: 'right', border: 'none', borderLeft: '2px solid #D1D5DB', minWidth: '80px', outline: 'none', backgroundColor: 'transparent' }} maxLength={10} pattern="[A-Za-z0-9]+" />
                                                    </div>

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                        <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}>Other amt:</label>
                                                        <input type="text" name="Oth_amt" value={poData.PO_HDR.Oth_amt}
                                                            style={{ textAlign: 'right', border: 'none', borderLeft: '2px solid #D1D5DB', minWidth: '80px', outline: 'none', backgroundColor: 'transparent' }} maxLength={10} pattern="[A-Za-z0-9]+" />
                                                    </div>

                                                </div>

                                            </div>
                                            <Row>
                                                <Col md={8}>
                                                    <div style={{ display: 'flex', textAlign: 'right', marginTop: '10px', color: 'black' }}>

                                                        <strong>Amount in Words: </strong>  <span style={{ textTransform: 'uppercase', borderBottom: '1px solid black', width: '300px', display: 'inline-block' }}>

                                                            {amountInWords}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div style={{ textAlign: 'right', justifyContent: 'space-between' }}>
                                                        <label style={{ color: 'darkblue' }}>Grand Total:</label>
                                                        <input type="text" name="Total_amt" value={poData.PO_HDR.Total_amt || 0}
                                                            style={{ textAlign: 'right', border: 'none', minWidth: '70px', outline: 'none', backgroundColor: 'transparent' }} />
                                                    </div>
                                                </Col>

                                            </Row>

                                        </>
                                    </div>
                                )} */}
